import {
    FETCH_PROPERTIES,
    FETCH_PROPERTIES_FAILURE,
    FETCH_PROPERTIES_SUCCESS,

    FETCH_PROPERTY,
    FETCH_PROPERTY_FAILURE,
    FETCH_PROPERTY_SUCCESS,

    FETCH_PROPERTY_LOCALISATION,
    FETCH_PROPERTY_LOCALISATION_FAILURE,
    FETCH_PROPERTY_LOCALISATION_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchProperties = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size || 24,
        sort_by: payload.field || 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'desc',
    };

    if (payload.name) {
        params.name = payload.name;
    }

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_PROPERTIES,
        payload: params,
    };
};

export const fetchPropertiesFailure = (error) => {
    return {
        type: FETCH_PROPERTIES_FAILURE,
        error: error,
    };
};

export const fetchPropertiesSuccess = (payload) => {
    return {
        type: FETCH_PROPERTIES_SUCCESS,
        payload: payload,
    };
};

// Fetch Property
export const fetchProperty = (payload) => {
    return {
        type: FETCH_PROPERTY,
        payload: payload,
    };
};

export const fetchPropertyFailure = (error) => {
    return {
        type: FETCH_PROPERTY_FAILURE,
        error: error,
    };
};

export const fetchPropertySuccess = (response) => {
    return {
        type: FETCH_PROPERTY_SUCCESS,
        response: response,
    };
};

// Fetch Property localisation
export const fetchPropertyLocalisation = (payload) => {
    return {
        type: FETCH_PROPERTY_LOCALISATION,
        payload: payload,
    };
};

export const fetchPropertyLocalisationFailure = (error) => {
    return {
        type: FETCH_PROPERTY_LOCALISATION_FAILURE,
        error: error,
    };
};

export const fetchPropertyLocalisationSuccess = (payload, response) => {
    return {
        type: FETCH_PROPERTY_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/properties/fetchProperties.js